(function($){

    ajaxinate();
    onclickfunction();
    custom();

    // document.addEventListener('theme:loading:end', function(event) {
    //     CreateWishlistButton();
    //     ajaxinate();
    // });
  
  
    
  $('.DrawerMobile .Collections__FiltersItemBody').each(function(){
  	let linklist = $(this).find('li'),
        linklistlink = linklist.find('a');
    
    linklist.on('click', function(e){
      $(this).toggleClass('current');
      e.preventDefault();
      
      
    });
    linklistlink.on('click', function(e){
      e.preventDefault();
    });
  });

  
  
  
  $('.filtermobile').on('click', function(){
        let handleURL = '';
        $('.Collections__FiltersItemBody .current').each(function(){
          handleURL = handleURL + (handleURL !== '' ? '+': '') + $(this).data('handle');
        });
    
    
        window.location= ($('.DrawerMobile').data('current-url') + handleURL);
  
  });
   

})(jQuery);

function ajaxinate(){

    // new Ajaxinate({
    //     method: "click",
    //     container: '#AjaxinateLoop',
    //     pagination: '#AjaxinatePagination',
    //     loadingText: 'Loading',
    //     callback: function(){
    //         CreateWishlistButton(); 
    //     }
    // });

    document.addEventListener("DOMContentLoaded",  function() {
        var endlessScroll = new Ajaxinate({
            method: "click",
            container: '#AjaxinateLoop',
            pagination: '#AjaxinatePagination',
            loadingText: 'Loading'
        });
    });

}


function onclickfunction(){

    $(".Footer__Block--links__Head").click(function() {
        if ($('.Footer__Block--links__Body').is(':visible')) {
            $(".Footer__Block--links__Body").slideUp(300);
            $(".Footer__Title__icon").removeClass('active'); 
        }
        if ($(this).next(".Footer__Block--links__Body").is(':visible')) {
            $(this).next(".Footer__Block--links__Body").slideUp(300);
            $(".Footer__Title__icon").removeClass('active');
        } else {
            $(this).next(".Footer__Block--links__Body").slideDown(300);
            $(".Footer__Title__icon").addClass('active');
        }
    });

    $(".Collections__FiltersItemHead").click(function() {
        if ($('.Collections__FiltersItemBody').is(':visible')) {
            $(".Collections__FiltersItemBody").slideUp(300);
            $(".Icon__Plus").removeClass('hide');
        }
        if ($(this).next(".Collections__FiltersItemBody").is(':visible')) {
            $(this).next(".Collections__FiltersItemBody").slideUp(300);
            $(this).children(".Icon__Plus").removeClass('hide');
        } else {
            $(this).next(".Collections__FiltersItemBody").slideDown(300);
            $(this).children(".Icon__Plus").addClass('hide');
        }
    });

    $(".Link__buttonPopup").click(function(){
        $(".FeatureText__Popup__Wrapper").addClass("visible");
        $('body').css('overflow', 'hidden'); 
    });

    $(".FeatureText__Popup__Wrapper span").click(function(){
        $(".FeatureText__Popup__Wrapper").removeClass("visible");
        $('body').css('overflow', 'visible'); 
    });

    $(".Breadcrumbs__country").click(function(){
        $(".Multicolumn__Popup").toggleClass("visible");
    });

    
    $(".Heading__Account").click(function(){
        $(".Customer__LoginPopup__Wrapper").addClass("visible");
        $('body').css('overflow', 'hidden'); 
    });

    $(".Customer__LoginClose").click(function(){
        $(".Customer__LoginPopup__Wrapper").removeClass("visible");
        $('body').css('overflow', 'visible');  
    });

    $(".ArticleToolbar__Nav__Wrapper .ArticleToolbar__ShareLabel").click(function(){
        $(".ArticleToolbar__Nav__Wrapper .ArticleToolbar__ShareList .HorizontalList").toggleClass("is-visible");
    });

    $(".CollectionToolbar__Item--filter__Open").click(function(){
        $(".CollectionInner__Sidebar").slideToggle("600");
        $(".Icon__Plus").toggleClass("hide"); 
    });

    $(".white-popup__close").click(function(){
        $(".pop-wrap").fadeOut("500");
    });


    $(".Multicolumn__Item").click(function() {
        if ($('.Multicolumn__ItemPopup').is(':visible')) {
            $(".Multicolumn__ItemPopup").slideUp(300);
        }
        if ($(this).next(".Multicolumn__ItemPopup").is(':visible')) {
            $(this).next(".Multicolumn__ItemPopup").slideUp(300);
        } else {
            $(this).next(".Multicolumn__ItemPopup").slideDown(300);
        }
    });

    $(".Faq__TitleM").click(function() {
        if ($('.Faq__ContentM').is(':visible')) {
            $(".Faq__ContentM").slideUp(300);
        }
        if ($(this).next(".Faq__ContentM").is(':visible')) {
            $(this).next(".Faq__ContentM").slideUp(300);
        } else {
            $(this).next(".Faq__ContentM").slideDown(300);
        }
    });

    $('.FaqList li a').on('click', function(){
        var target = $(this).attr('data-rel');
     $('.FaqList li a').removeClass('active');
        $(this).addClass('active');
        $("#"+target).fadeIn('slow').siblings(".FaqList__ContentItem").hide();
        return false;
    });
     
}


function custom(){
    var child_count = $('.text_img_link_slider').children().length;

    if (child_count >= 3) {
        $('.text_img_link_slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 1025,
                    settings: {
                        slidesToShow: 3
                    }
                }
            ]
        });
    }



    if ($(window).width() < 1008) {
        $( ".collapsible_section" ).each(function() {
            $(this).children('.collapsible_toggle').addClass('active');
            $( this ).children('.collapsible_toggle').click(function(){
                $(this).parent().children().not(":first-child").slideToggle(300);
                $(this).toggleClass('active');
            });
        });
    }
    
    

    $('.product-tabs').click(function(){
        var anchor_attr = $(this).attr('data-anchor');
        console.log(anchor_attr)
        window.location.href = "#"+anchor_attr;
    })
    
}